// shadcn/ui's Card composition, reduced to the slots Valid Labels uses.
import * as React from "react";
import { cn } from "../../lib/utils";

export function Card({
  className,
  ...props
}: React.HTMLAttributes<HTMLElement>) {
  return <section className={cn("vl-card", className)} {...props} />;
}
export function CardHeader({
  title,
  hint,
  children,
}: {
  title: React.ReactNode;
  hint?: React.ReactNode;
  children?: React.ReactNode;
}) {
  return (
    <div className="vl-card-header">
      <div>
        <h2 className="vl-card-title">{title}</h2>
        {hint && <p className="vl-card-hint">{hint}</p>}
      </div>
      {children}
    </div>
  );
}
export function CardBody({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("vl-card-body", className)} {...props} />;
}
